import { Box, Tooltip } from "@mui/material";
import { useRef, useState } from "react";

export default function TruncatedCell({ children, displayText }) {
  const textRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const checkOverflow = () => {
    if (textRef.current) {
      setIsOverflowing(textRef.current.scrollWidth > textRef.current.clientWidth);
    }
  };

  return (
    <Tooltip
      title={displayText}
      placement="top"
      arrow
      disableHoverListener={!isOverflowing}
      slotProps={{
        tooltip: {
          sx: {
            backgroundColor: "#000000",
            color: "#ffffff",
            fontSize: "0.875rem",
            padding: "8px 12px",
            maxWidth: "400px",
            zIndex: 999999,
            "& .MuiTooltip-arrow": {
              color: "#000000",
            },
          },
        },
        popper: {
          sx: {
            zIndex: 999999,
          },
        },
      }}
    >
      <Box
        ref={textRef}
        onMouseEnter={checkOverflow}
        sx={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {children}
      </Box>
    </Tooltip>
  );
}
